import { render, staticRenderFns } from "./SellerRelateTable.vue?vue&type=template&id=dde33a8c&scoped=true"
import script from "./SellerRelateTable.vue?vue&type=script&lang=js"
export * from "./SellerRelateTable.vue?vue&type=script&lang=js"
import style0 from "./SellerRelateTable.vue?vue&type=style&index=0&id=dde33a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde33a8c",
  null
  
)

export default component.exports